import Common from '../../../Common';
import { FileType } from '../../../Enums';

const Call = class extends Common {
	async browse(
		companyId: id,
		options: {
			limit?: number,
			limit_from?: number,
			from?: string,
			to?: string,
			search?: string,
			weekly_stats?: number,
			order_by?: string,
			order_dir?: string,
			weekdays?: any[],
			queues?: any[],
			users?: any[],
		}
	) {
		return this.get(`/company/${companyId}/queuestat/calls${this.getGETVariables(options)}`);
	}

	async browseDownload(
		companyId: id,
		options: {
			limit?: number,
			limit_from?: number,
			from?: string,
			to?: string,
			search?: string,
			weekly_stats?: number,
			order_by?: string,
			order_dir?: string,
			weekdays?: any[],
			queues?: any[],
			users?: any[],
			downloadType: FileType,
		}
	) {
		return this.get(`/company/${companyId}/queuestat/calls/download${this.getGETVariables(options)}`, {}, { responseType: 'blob' });
	}

	async read(companyId: id, uniqueId: string) {
		return this.get(`/company/${companyId}/queuestat/calls/${uniqueId}`);
	}

	async readDownload(companyId: id, uniqueId: string, downloadType: FileType) {
		return this.get(`/company/${companyId}/queuestat/calls/${uniqueId}/download${this.getGETVariables({ downloadtype: downloadType })}`, {}, { responseType: 'blob' });
	}
}

export default Call;
